<template>
  <v-btn
    :elevation="0"
    color="#cb0c9f"
    class="
      font-weight-bolder
      btn-danger
      bg-gradient-danger
      py-4
      px-8
      mt-auto
      text-white
    "
    :class="width ? width : 'w-100'"
    small
    :disabled="!disabled"
    @click="btnBlueClicked"
  >
    {{ btnTitle }}
  </v-btn>
</template>

<script>
export default {
  name: "BtnRed",
  props: {
    btnTitle: {
      type: [String, Number],
      default: "BTN TITLE",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [String, null],
      default: null,
    },
  },

  methods: {
    btnBlueClicked() {
      this.$emit("clicked");
    },
  },
};
</script>

<style scoped></style>
